import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDossier: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDossier"><Path d="M9.5 4.5V8.5H21.5M9.5 4.5H2.5V19.5H21.5V8.5M9.5 4.5H15.5M21.5 8.5V4.5H15.5M15.5 4.5V8.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDossier;
